// extracted by mini-css-extract-plugin
export var originalPrice = "_tu-0";